//Api
import request from '@/utils/request'

export default {
  /***公司管理   api */
   createIntr:(data)=>{
    return request({
      url: '/org/createCompany',
      method: 'POST',
      data:data
    })
  },
  deleteIntr:(id)=>{
    return request({
      url: `/org/deleteCompany/${id}`,
      method: 'GET',
    })
  },
  updateIntr:(id,data)=>{
    return request({
      url: `/org/updateCompany/${id}`,
      method: 'POST',
      data:data
    })
  },
  pageList:(data)=>{
    return request({
      url: `/org/pageCompany`,
      method: 'GET',
      params:data
    })
  },
  //获取公司
  getAllList:(data)=>{
    return request({
      url: `/org/listCompany`,
      method: 'GET',
      params:data
    })
  },
  //解卡  全局  type =2
  getAllListType2:(data)=>{
    return request({
      url: `/org/listCompany`,
      method: 'GET',
      params:{...data,type:2}
    })
  },
  //解债  债务  全局  type =1
  getAllListType1:(data)=>{
    return request({
      url: `/org/listCompany`,
      method: 'GET',
      params:{...data,type:1}
    })
  },
  getAllCompanyList:(data)=>{
    return request({
      url: `/org/listAllCompany`,
      method: 'GET',
      params:data
    })
  },
  getGsTimeAllList:(data)=>{
    return request({
      url: `/org/getListTimeCompany`,
      method: 'GET',
      params:data
    })
  },
  checkByIdDetail:(id,data)=>{
    return request({
      url: `/org/getCompanyInfo/${id}`,
      method: 'GET',
      params:data
    })
  },

  //文件上传
  uploadFileIntr:(data)=>{
    return request({
      url: `/xinyebang/uploadFile?id=${data.id}`,
      method: 'POST',
      data:{}
    })
  },

  
  //欣业邦查询账户余额
  queryBalance:(id)=>{
    return request({
      url: `/order/queryBalance?id=${id}`,
      method: 'POST',
      data:{}
    })
  },
  //欣业邦申请提现
  withdrowApply:(data)=>{
    return request({
      url: `/order/withdrowApply`,
      method: 'POST',
      data:data
    })
  },
  //欣业邦渠道转账
  channelTransfer:(data)=>{
    return request({
      url: `/order/channelTransfer`,
      method: 'POST',
      data:data
    })
  },

  //查询公司列表=》显示名称   余额
  queryCompanyBalance:(data)=>{
    return request({
      url: `/order/queryCompanyBalance`,
      method: 'POST',
      data:data
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/companyManagementApi.js